import React, { useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import clsx from 'clsx'
import Button from '../Button/Button'
import CMSText from '../Global/CMSText'
import DownloadLink from '../Global/DownloadLink'
import Loader from '../Loader/Loader'
import { downloadURI } from '../../utils/utils'
import { getOrderReturnLabel } from '../../redux/services/order'
import useOrderStyle from './Order.style'

type Tprops = {
  orderNumber: string
  account: any
  t: (key: string) => string
}

const RentalReturnLabelDownload = ({ orderNumber, account, t }: Tprops) => {
  const classes = useOrderStyle()
  const [downloadLink, setDownloadLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isUnavailable, setIsUnavailable] = useState(false)

  const handleDownload = async () => {
    setIsLoading(true)
    setIsUnavailable(false)
    try {
      const response = await getOrderReturnLabel(orderNumber)
      if (response?.pdfUrl) {
        setDownloadLink(response.pdfUrl)
        downloadURI(
          response.pdfUrl,
          `${process.env.STORE}_${response.trackingCode || orderNumber}`
        )
      } else {
        setIsUnavailable(true)
      }
    } catch {
      setIsUnavailable(true)
    } finally {
      setIsLoading(false)
    }
  }

  if (isUnavailable) {
    return (
      <Typography variant="body2" color="textSecondary">
        <CMSText
          data={account?.data?.return_label_unavailable}
          defaultText={t('texts:account:return_label_unavailable')}
        />
      </Typography>
    )
  }

  return (
    <Box
      textAlign="center"
      className={clsx(classes.returnCtaContainer, 'return_label_download')}
    >
      {downloadLink === '' ? (
        <Button
          size="small"
          data-testid="returnLabelDownloadBtn"
          variant="contained"
          color="secondary"
          disabled={isLoading}
          onClick={handleDownload}
        >
          <span className={isLoading ? classes.hide : classes.show}>
            <CMSText
              asText
              data={account?.data?.order_details_generate}
              defaultText={t('texts:account:order_details_generate')}
            />
          </span>
          {isLoading && <Loader />}
        </Button>
      ) : (
        <DownloadLink
          downloadLink={downloadLink}
          data={account?.data?.order_details_download}
          defaultText={t('texts:account:order_details_download')}
        />
      )}
    </Box>
  )
}

export default RentalReturnLabelDownload
